import { render } from "./index.vue?vue&type=template&id=376d4b35&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=376d4b35&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376d4b35"],['__file',"src/views/apartment/room/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "376d4b35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('376d4b35', __exports__)) {
    console.log('reload')
    api.reload('376d4b35', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=376d4b35&scoped=true", () => {
    console.log('re-render')
    api.rerender('376d4b35', render)
  })

}


export default __exports__